<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>기술자료실</p>
                <ChevronRight :size="24"></ChevronRight>
                <p>다운로드</p>
            </div>
        </div>

        <div id="product-select" class="column screen-width">
            <p style="font-size: 32px; font-weight: bold">다운로드 자료실</p>
            <p style="font-size: 20px">• 제품 분류를 선택해주세요</p>
            <div class="row align-space-between" style="width: 100%">
                <div
                    id="product-list"
                    style="display: flex; align-content: center"
                >
                    <text-button
                        v-for="(category, index) in categoryList"
                        :key="index"
                        :textSize="14"
                        :buttonName="category"
                        :buttonStyle="{
                            border: '1px solid #CECECE',
                            background: 'white',
                        }"
                        @click="selectCategory(index)"
                        :clicked="index == selectedCategory"
                    ></text-button>
                </div>
            </div>
        </div>

        <div id="model-select" class="column screen-width">
            <p style="font-size: 20px">• 제품 모델을 선택해주세요.</p>
            <div class="row" style="width: 100%">
                <div
                    id="model-list"
                    style="display: flex; align-content: center"
                >
                    <p
                        v-for="(model, index) in product_model"
                        :key="index"
                        style="width: 45%; cursor: pointer"
                        :class="{ selected: selectedModel?.id == model.id }"
                        @click="selectModel(model)"
                    >
                        • {{ model.sub_category }}
                    </p>
                </div>
            </div>
        </div>

        <div id="data" class="screen-width">
            <div class="row" style="gap: 14px; margin-bottom: 16px">
                <p style="font-size: 28px; font-weight: bold; color: #00a7e7">
                    {{ selectedModel?.sub_category ? selectedModel.sub_category : categoryList[selectedCategory]}}
                </p>
                <p style="font-size: 28px; font-weight: bold">다운로드 자료</p>
            </div>
            <div id="data-list">
                <notice-item
                    v-for="notice in downloadNoticeList"
                    :key="notice"
                    :id="notice.id"
                    :title="notice.title"
                    :category="notice.categories[0]?.sub_category"
                    :date="notice.createdAt">
                </notice-item>
                <download-item
                    v-for="download in downloadList"
                    :key="download"
                    :title="download.title"
                    :filename="download.file_name"
                    :hasFile="download.hasFile"
                    :url="download.url"
                    :content="download.content"
                    :category="formatCategory(download.categories)"
                    :date="download.createdAt"
                ></download-item>
            </div>
            <custom-pagination
                style="margin-top: 32px"
                :currentPage="currentPage"
                :totalPages="totalPages"
                v-on:update="loadPageData"
            ></custom-pagination>
        </div>
    </v-container>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import TextButton from "@/components/TextButton.vue";
import SearchBar from "@/components/SearchBar.vue";
import DownloadItem from "@/components/DownloadItem.vue";
import CustomPagination from "@/components/CustomPagination.vue";
import NoticeItem from "@/components/NoticeItem.vue"

export default {
    name: "problem-layout",
    components: {
        HomeOutline,
        ChevronRight,
        TextButton,
        SearchBar,
        DownloadItem,
        CustomPagination,
        NoticeItem
    },
    setup() {
        const store = useStore();
        const categoryList = [
            "전체",
            "GPS플로터",
            "레이더",
            "무선/통신장비",
            "항해 안전장비",
            "항해 조타장비",
            "해상용 안테나/헤딩센서",
            "선박용 인산철배터리",
            "선박용 전기관련 제품",
            "부품 및 액세서리",
        ];

        const selectedCategory = ref(0);

        const product_model = computed(() => {
            return store.getters.getSubCategoryList;
        });

        const downloadList = computed(() => {
            return store.getters.getDownloadList;
        });

        const downloadNoticeList = computed(() => {
            return store.getters.getDownloadNoticeList;
        });


        const selectedModel = ref(0);

        const selectCategory = async (index) => {
            selectedCategory.value = index;
            if (index == 0) {
                selectedModel.value = null;
                store.commit("setSubCategoryList", []);
                getDownloadList();
                getDownloadNoticeList();
                return ;
            }
            await store.dispatch("getSubCategoryDownloadList", index - 1);
            selectedModel.value = product_model.value[0];
            currentPage.value = 1;
            getDownloadNoticeList();
            getDownloadList();
        };

        const selectModel = async (model) => {
            selectedModel.value = model;
            currentPage.value = 1;
            getDownloadList();
            getDownloadNoticeList();
        };

        const currentPage = ref(1);
        const totalPages = computed(() => {
            return Math.ceil(store.getters.getDownloadTotalCount / 10);
        });

        const loadPageData = (page) => {
            currentPage.value = page;
            getDownloadList();
        };

        const getDownloadList = () => {
            // ✅ 모델이 '전체'면 categoryId가 아니라 mainCategoryId로 메인 전체(전체+서브 전체)를 조회
            const isWholeModel = selectedModel.value?.sub_category === "전체";
            const mainCategoryId =
                selectedCategory.value && selectedCategory.value > 0
                    ? selectedCategory.value - 1
                    : null;
            store.dispatch("getDownloadList", {
                categoryId:
                    selectedModel.value?.id && !isWholeModel
                        ? selectedModel.value.id
                        : null,
                mainCategoryId: isWholeModel ? mainCategoryId : null,
                take: 10,
                page: currentPage.value,
            });
        }

        const getDownloadNoticeList = () => {
            const isWholeModel = selectedModel.value?.sub_category === "전체";
            const mainCategoryId =
                selectedCategory.value && selectedCategory.value > 0
                    ? selectedCategory.value - 1
                    : null;
            store.dispatch("getDownloadNoticeList", {
                categoryId:
                    selectedModel.value?.id && !isWholeModel
                        ? selectedModel.value.id
                        : null,
                mainCategoryId: isWholeModel ? mainCategoryId : null,
            });
        }

        const formatCategory = (category) => {
            const subCategory = category.map(c => c.sub_category)
            return subCategory.join(', ')
        }

        onMounted(async () => {
            // await store.dispatch("getSubCategoryList", 0);
            // if (product_model.value.length > 0) {
            //     selectedModel.value = product_model.value[0];
            // }
            getDownloadList();
            getDownloadNoticeList();
        });

        return {
            selectCategory,
            selectedCategory,
            selectedModel,
            selectModel,
            currentPage,
            totalPages,
            loadPageData,
            categoryList,
            product_model,
            downloadList,
            getDownloadNoticeList,
            downloadNoticeList,
            formatCategory
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

.selected {
    color: #00a7e7;
    font-weight: bold;
}

#product-select {
    padding: 40px 0px;
    gap: 24px;
    flex-wrap: wrap;
}

#product-list {
    width: 100%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
    flex-wrap:wrap;
}

#model-select {
    padding: 40px 0px;
    gap: 24px;
}

#model-list {
    width: 100%;
    height: auto;
    padding: 0px 30px;
    gap: 16px;
    flex-wrap: wrap; /* 이 설정이 요소들을 자동으로 줄 바꿈하게 합니다 */
}

#data {
    padding: 32px 0px;
}

#data-list {
    width: 100%;
    border-top: 1px solid black;
}
</style>
